import {Component} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {ActivatedRoute} from '@angular/router';
import * as fromRoot from './app.reducer';
import * as actions from './modules/core/actions/authentication';
import {Store} from '@ngrx/store';
import {KvItem} from './modules/core/models/kv-item';
import * as fromSite from './modules/irar/reducers';
import * as siteActions from './modules/irar/actions/site';

@Component({
  selector: 'app-root',
  template: `
    <div id="container">
      <app-header></app-header>
      <div id="mainContent">
        <h2 class="offleft">Main Content</h2>
        <dandp-breadcrumb></dandp-breadcrumb>
        <router-outlet></router-outlet>
      </div>
      <app-footer></app-footer>
    </div>
  `
})
export class AppComponent {
  loggedIn$: Observable<boolean>;
  name$: Observable<string>;
  isAdmin$: Observable<boolean>;
  isAliasing$: Observable<boolean>;
  isSuperAdmin$: Observable<boolean>;
  role$: Observable<string>;
  pageName: string;

  constructor(private store: Store<fromRoot.State>,
              private siteStore: Store<fromSite.State>,
              private route: ActivatedRoute) {
    this.loggedIn$ = this.store.select(fromRoot.getAuthLoggedIn);
    this.name$ = this.store.select(fromRoot.getAuthFullName);
    this.isAdmin$ = this.store.select(fromRoot.getAuthIsAdmin);
    this.isSuperAdmin$ = this.store.select(fromRoot.getAuthIsSuperAdmin);
    this.isAliasing$ = this.store.select(fromRoot.getAuthIsAliasing);
    this.role$ = this.store.select(fromRoot.getAuthRole);
    this.siteStore.dispatch(new siteActions.LoadAllFarmsAction());
    this.siteStore.dispatch(new siteActions.LoadAllSitesAction());
    this.siteStore.dispatch(new siteActions.LoadAuthorsAction());
    this.store.dispatch(new siteActions.LoadFarmGpsAction());
    this.store.dispatch(new siteActions.LoadAocGpsAction());
  }
  logOut() {
    this.store.dispatch(new actions.LogoutAction());
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/app.component.ts